import React from 'react';

const Crumb = ({title,slogan}) => {
  return (
    <div className="crumb d-flex justify-content-center align-items-end">
      <div className="crumb_inner text-center pb-5">
        <h1 style={{fontSize: `3rem`}} className="text-white font-weight-bold">{title}</h1>
        <h4 className="text-white font-weight-light">{slogan}</h4>
      </div>
    </div>
  );
};

export default Crumb;